import { Component, Input } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
    selector: 'app-modal-content',
    template: `
    <div class="modal-header">
        <h5 class="modal-title text-center">{{nom_dr}}</h5>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body"> 
    <video title="Dr imisa" preload="auto" controls width="400" class="center-block">
        <source src="assets/video/{{video_name}}" type="video/mp4">
        <p>Dr Imisa</p>
    </video>
    <div class="text-center">
        <figcaption>Médecin spécialiste diplômé d'Etat</figcaption>
        <figcaption>NEURO-PSYCHIATRE</figcaption>
        <figcaption>ONM: 02 12 22 31 410 8450</figcaption>
        <figcaption>Lieu : Antaninarenina</figcaption>
        <figcaption>Porte : 41</figcaption>

    </div>
    </div>

  








    <div class="modal-footer">
    <div class="left-side">
        <button type="button" class="btn btn-default btn-link" (click)="Evaluation()">Evaluation</button>
    </div>
    <div class="divider"></div>
    <div class="right-side">
        <button type="button" class="btn btn-danger btn-link" (click)="activeModal.close('Close click')">Fermer</button>
    </div>
</div>
    `
})
export class NgbdModalContent {
    @Input() name;
    nom_dr: string = "";
    mode_dr:number = 3;
    video_name: string = "";

    constructor(public activeModal: NgbActiveModal,private router: Router) {
      
       if ( this.mode_dr==2){
        this.nom_dr="Dr Imisa";
       this.video_name ="dr_Imisa.mp4"
       }else  if ( this.mode_dr==1){
        this.nom_dr="Dr Tiana";
        this.video_name ="dr_Hery.mp4"
       }else  if ( this.mode_dr==3){
        this.nom_dr="Dr Tiana";
        this.video_name ="dr_Fanja.mp4"
       }
    }
    Evaluation(){
        this.activeModal.close('Close click')
        this.router.navigate(['evaluation']);
      }
}

@Component({
    selector: 'app-ajout-docteur-tsz',
    templateUrl: './ajout-docteur-tsz.component.html',
    styleUrls: ['./ajout-docteur-tsz.component.scss']
})
export class AjoutDocteurTszComponent {
   
    user_connected: any;
    nom_dr: string = "Dr Tiana";
    constructor(private modalService: NgbModal) { }
    open() {
        const modalRef = this.modalService.open(NgbdModalContent);
        modalRef.componentInstance.name = 'World';
    }
    ngOnInit() {
    }

    

}
